module.exports = __webpack_public_path__ + "static/img/partner-thfj.e326ff5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-thfj.png
// module id = xLGB
// module chunks = 34